import React from 'react';
const SkeletonCard = () => (
  <div className="skeleton w-48 h-64 rounded-lg"></div>
);
export default SkeletonCard;
